import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  header: {
    alignItems: "center",
    backgroundColor: palette.primary.main,
    color: palette.background.paper,
    display: "flex",
    fontSize: 16,
    height: spacing(8),
    justifyContent: "flex-end",
    left: spacing(8),
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 900,
  },
  "header--expanded": {
    left: spacing(4 * 8),
  },
}));
